import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const updateGovReportingFacilityMutationAtom = createMutationAtomFactory(
  'settings.govReportingFacilityUpdate',
  (params: { id: string; reportingFacilityId?: string; mlid?: string }) => ({
    complianceGovernmentReportingFacilityUpdate: {
      __args: {
        id: params.id,
        input: {
          reportingFacilityId: params.reportingFacilityId,
          mlid: params.mlid,
        },
      },
      id: true,
    },
  }),
);
